import { isAxiosError } from "axios";
import { StatusCodes } from "http-status-codes";
import {
    PARAMETER_GROUP_NOT_FOUND_ERROR,
    PARAMETER_GROUP_NOT_FOUND_MESSAGE,
    PARAMETER_GROUP_NOT_FOUND_TITLE,
} from "constants/filters";
import { getServerError } from "./get-server-error";
import { notifications } from "@edgetier/global-components";

/**
 * Whether an error is the API's "saved filters are no longer available" (expired parameter group) response.
 * @param serverError Backend error.
 */
const isParameterGroupNotFoundError = (serverError: unknown): boolean =>
    isAxiosError(serverError) &&
    serverError.response?.status === StatusCodes.NOT_FOUND &&
    (serverError.response?.data as { error?: string })?.error === PARAMETER_GROUP_NOT_FOUND_ERROR;

/**
 * Show a server error as a toast message.
 * @param serverError Backend error.
 */
export const showServerError = (serverError: any) => {
    if (isParameterGroupNotFoundError(serverError)) {
        notifications.warning({ title: PARAMETER_GROUP_NOT_FOUND_TITLE, message: PARAMETER_GROUP_NOT_FOUND_MESSAGE });
        return;
    }
    notifications.error(getServerError(serverError));
};
